import { Stack } from '@mui/material'
import { EFTypography } from '~/components'
import { IErrorPopupContent } from './ErrorPopupContent.model'
import { t } from 'i18next'

export function ErrorPopupContent({ error }: IErrorPopupContent) {
  if (error.status === 500) {
    return (
      <Stack direction='column'>
        <EFTypography
          my={1}
          whiteSpace='pre-wrap'
        >
          {t('Message_ServerError')}
        </EFTypography>
      </Stack>
    )
  }
  if (!error.data) {
    return (
      <Stack direction='column'>
        <EFTypography
          my={1}
          whiteSpace='pre-wrap'
        >
          {(error as any).message}
        </EFTypography>
      </Stack>
    )
  }
  return (
    <Stack direction='column'>
      {error.data.messages
        ? error.data.messages.map((message: any) => (
            <EFTypography
              my={1}
              key={message}
            >
              {message}
            </EFTypography>
          ))
        : Object.values(error.data)
            .flat()
            .map((message: any) => (
              <EFTypography
                my={1}
                key={message}
              >
                {message}
              </EFTypography>
            ))}
    </Stack>
  )
}
